import moment from "moment";
import { displayDateFormat } from "../../../utils/helpers";

export const l1ApprovedColumns = ({ extraColumns = [], downloadVoucher }) => [
  ...extraColumns,
  {
    Header: "Submit On",
    accessor: "submittedOn",
    Cell: (props) => {
      let subimttedOnData = props.submittedOn || props?.row?.original?.submittedOn
      if (!subimttedOnData) {
        return "-";
      }
      return (
        <div>
          {moment(
            subimttedOnData).format(displayDateFormat)}
          {/* {props?.row?.original?.submittedOn} */}
        </div>
      );
    },
  },
  {
    Header: "Requested Amount(₹)",
    accessor: "amount",
    Cell: (props) => {
      const value = props?.amount || props?.row?.original?.amount;
      let amount;
      if(typeof value == "string"){
        amount = Number(value).toFixed(2);
      } else {
        amount = value
      }

      return (
        <div>{amount || ""}</div>
      );
    }
  },
  {
    Header: "Approved Amount(₹)",
    accessor: "approvedAmount",
  },

  {
    Header: "Status",
    accessor: "approvedAmount",
    Cell: () => {
      return <div className={"text-[var(--successGreen)]"}>Approved</div>;
    },
  },
  {
    Header: "Action",
    accessor: "",
    Cell: (rowData) => { 
      return (
        <div className="flex items-center gap-x-5">
          <div
            className={`cursor-pointer text-[#346BFF] underline text-[1.4rem]}`}
            onClick={() => {
              // return onClickViewFile(rowData?.id, rowData)
              downloadVoucher(rowData, "Approved")
            }}
          >
            Download
          </div>
        </div>
      );
    },
  },
  // {
  //   Header: "Approved",
  //   accessor: "approvedAmount",
  //   Cell: (props) => {
  //     const value = props?.row?.original?.approvedAmount;
  //     if (!value) {
  //       return "-";
  //     }
  //     return <div className={"text-[var(--successGreen)]"}>{value}</div>;
  //   },
  // },
];
